/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, computed, createVNode } from 'vue';
import { CloseCircleFilledIcon, ErrorCircleFilledIcon, CheckCircleFilledIcon } from 'tdesign-icons-vue-next';
import { Loading } from '../loading/index.mjs';
import props from './props.mjs';
import { abridgeName } from './util.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import { useGlobalIcon } from '../hooks/useGlobalIcon.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { useConfig } from '../config-provider/useConfig.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../_chunks/dep-dcf624da.mjs';
import '../_chunks/dep-556a2f2c.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/set-style.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-8c39d78a.mjs';
import '../_chunks/dep-e68fd68c.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';
import '../utils/dom.mjs';
import '../_chunks/dep-2684fd15.mjs';
import '../utils/easing.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../utils/transfer-dom.mjs';
import '../loading/props.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../loading/type.mjs';

var SingleFileProps = {
  file: {
    type: Object,
    "default": function _default() {
      return null;
    }
  },
  loadingFile: {
    type: Object,
    "default": function _default() {
      return null;
    }
  },
  percent: {
    type: Number
  },
  showUploadProgress: props.showUploadProgress,
  theme: props.theme,
  placeholder: props.placeholder,
  onRemove: Function
};
var SingleFile = defineComponent({
  name: "TUploadSingleFile",
  props: SingleFileProps,
  setup: function setup(props2) {
    var renderTNodeJSX = useTNodeJSX();

    var _useConfig = useConfig("upload"),
        prefix = _useConfig.classPrefix;

    var UPLOAD_NAME = usePrefixClass("upload");

    var _useGlobalIcon = useGlobalIcon({
      CloseCircleFilledIcon: CloseCircleFilledIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon,
      CheckCircleFilledIcon: CheckCircleFilledIcon
    }),
        CloseCircleFilledIcon$1 = _useGlobalIcon.CloseCircleFilledIcon,
        ErrorCircleFilledIcon$1 = _useGlobalIcon.ErrorCircleFilledIcon,
        CheckCircleFilledIcon$1 = _useGlobalIcon.CheckCircleFilledIcon;

    var showProgress = computed(function () {
      return !!(props2.loadingFile && props2.loadingFile.status === "progress");
    });
    var inputName = computed(function () {
      var fileName = props2.file && props2.file.name;
      var loadingName = props2.loadingFile && props2.loadingFile.name;
      return showProgress.value ? loadingName : fileName;
    });
    var inputText = computed(function () {
      return inputName.value || props2.placeholder;
    });
    var inputTextClass = computed(function () {
      return ["".concat(prefix.value, "-input__inner"), _defineProperty({}, "".concat(UPLOAD_NAME.value, "__placeholder"), !inputName.value)];
    });
    var classes = computed(function () {
      return ["".concat(UPLOAD_NAME.value, "__single"), "".concat(UPLOAD_NAME.value, "__single-").concat(props2.theme)];
    });

    var renderProgress = function renderProgress() {
      if (props2.loadingFile.status === "fail") {
        return createVNode(ErrorCircleFilledIcon$1, null, null);
      }

      if (props2.showUploadProgress) {
        return createVNode("div", {
          "class": "".concat(UPLOAD_NAME.value, "__single-progress")
        }, [createVNode(Loading, null, null), createVNode("span", {
          "class": "".concat(UPLOAD_NAME.value, "__single-percent")
        }, [Math.min(props2.percent, 99), "%"])]);
      }
    };

    var renderFilePreviewAsText = function renderFilePreviewAsText() {
      if (!inputName.value || props2.theme !== "file") return;
      return createVNode("div", {
        "class": "".concat(UPLOAD_NAME.value, "__single-display-text ").concat(UPLOAD_NAME.value, "__display-text--margin")
      }, [createVNode("span", {
        "class": "".concat(UPLOAD_NAME.value, "__single-name")
      }, [inputName.value]), showProgress.value ? renderProgress() : createVNode(CloseCircleFilledIcon$1, {
        "class": "".concat(UPLOAD_NAME.value, "__icon-delete"),
        "onClick": function onClick(_ref2) {
          var e = _ref2.e;
          return props2.onRemove(e);
        }
      }, null)]);
    };

    var renderFilePreviewAsInput = function renderFilePreviewAsInput() {
      if (props2.theme !== "file-input") return;

      var renderResult = function renderResult() {
        if (!!props2.loadingFile && props2.loadingFile.status === "fail") {
          return createVNode(ErrorCircleFilledIcon$1, null, null);
        }

        if (props2.file && props2.file.name && !props2.loadingFile) {
          return createVNode(CheckCircleFilledIcon$1, null, null);
        }

        return "";
      };

      return createVNode("div", {
        "class": "".concat(UPLOAD_NAME.value, "__single-input-preview ").concat(prefix.value, "-input")
      }, [createVNode("div", {
        "class": inputTextClass.value
      }, [createVNode("span", {
        "class": "".concat(UPLOAD_NAME.value, "__single-input-text")
      }, [abridgeName(inputText.value, 4, 6)]), showProgress.value && renderProgress(), renderResult()])]);
    };

    return function () {
      return createVNode("div", {
        "class": classes.value
      }, [renderFilePreviewAsInput(), renderTNodeJSX("default"), renderFilePreviewAsText()]);
    };
  }
});

export { SingleFile as default };
//# sourceMappingURL=single-file.mjs.map
